export default (setA, setB) => {
  const diff = new Set(setA);
  setB.forEach((el) => {
    diff.delete(el);
  });
  return diff;
};
